import { Prop, Vue } from 'vue-property-decorator';

export class WoModalBaseClass extends Vue {
  @Prop() wo: any;

  constructor() {
    super();
  }
}
